import React, { useState, useEffect } from 'react';
import { loginWithNostr, loginWithNsec, getToken, logout, authHeaders } from '../auth';

function shortKey(hex) {
  if (!hex) return '';
  return hex.slice(0, 8) + '…' + hex.slice(-4);
}

function getPubkeyFromToken(token) {
  try {
    return JSON.parse(atob(token.split('.')[1])).pubkey || '';
  } catch { return ''; }
}

const LINKS = [
  {
    label: 'Proton Mail',
    href: 'https://account.proton.me/mail',
    color: '#6d4aff',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
      </svg>
    ),
  },
  {
    label: 'new.vote',
    href: 'https://new.vote',
    color: '#3b82f6',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z" />
      </svg>
    ),
  },
  {
    label: 'Diary',
    href: 'https://diary.davidtwaddell.uk',
    color: '#14b8a6',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
      </svg>
    ),
  },
  {
    label: 'Tasks',
    href: 'https://tasks.davidtwaddell.uk',
    sso: true,
    color: '#f59e0b',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m-6 9 2 2 4-4" />
      </svg>
    ),
  },
  {
    label: 'Food',
    href: 'https://food.davidtwaddell.uk',
    sso: true,
    color: '#22c55e',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M8.25 3.75v6.75m0 0a3 3 0 0 1-3 3v7.5m3-10.5a3 3 0 0 0 3-3v-3.75M15 3.75v16.5m0-16.5c0 3.728 1.5 6.75 3.75 6.75v9.75" />
      </svg>
    ),
  },
  {
    label: 'ShareTask',
    href: 'https://sharetask.voter.care',
    color: '#84cc16',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 21c-4.5-2-7.5-6-7.5-10.5A7.5 7.5 0 0 1 12 3a7.5 7.5 0 0 1 7.5 7.5C19.5 15 16.5 19 12 21Zm0-10.5v6m0-6c0-2.485-1.5-4.5-3.75-4.5m3.75 4.5c0-2.485 1.5-4.5 3.75-4.5" />
      </svg>
    ),
  },
  {
    label: 'AlbyHub',
    href: 'https://alby.davidtwaddell.uk',
    color: '#fbbf24',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 10V3L4 14h7v7l9-11h-7Z" />
      </svg>
    ),
  },
  {
    label: 'dtmedia',
    href: '/dtmedia/admin',
    internal: true,
    color: '#a855f7',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <path d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
      </svg>
    ),
  },
  {
    label: 'NostrViz',
    href: 'https://nostrviz.davidtwaddell.uk',
    color: '#8b5cf6',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
        <path d="m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98"/>
      </svg>
    ),
  },
  {
    label: 'X',
    href: 'https://x.com/davidtwaddell',
    color: '#e8e8ea',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.259 5.632 5.905-5.632Zm-1.161 17.52h1.833L7.084 4.126H5.117Z" />
      </svg>
    ),
  },
];

const CONTACT_STYLES = `
  .dt-input {
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .dt-input:hover {
    border-color: #606070 !important;
    box-shadow: 0 0 0 3px rgba(90, 90, 150, 0.18);
  }
  .dt-input:focus {
    border-color: #7070a0 !important;
    box-shadow: 0 0 0 3px rgba(90, 90, 160, 0.28);
  }
  .dt-send-btn {
    transition: border-color 0.2s, box-shadow 0.2s, color 0.2s;
  }
  .dt-send-btn:hover:not(:disabled) {
    border-color: #707090 !important;
    box-shadow: 0 0 10px 2px rgba(100, 100, 180, 0.3);
    color: #d8d8e8 !important;
  }
`;

function ContactForm() {
  const [name, setName]       = useState('');
  const [email, setEmail]     = useState('');
  const [message, setMessage] = useState('');
  const [website, setWebsite] = useState('');
  const [status, setStatus]   = useState('idle');
  const [errMsg, setErrMsg]   = useState('');

  useEffect(() => {
    if (!document.getElementById('dt-contact-styles')) {
      const el = document.createElement('style');
      el.id = 'dt-contact-styles';
      el.textContent = CONTACT_STYLES;
      document.head.appendChild(el);
    }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus('sending');
    setErrMsg('');
    try {
      const r = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, message, website }),
      });
      const d = await r.json();
      if (!r.ok) { setErrMsg(d.error || 'Something went wrong'); setStatus('error'); return; }
      setStatus('sent');
    } catch {
      setErrMsg('Network error — please try again');
      setStatus('error');
    }
  }

  const inputStyle = {
    width: '100%',
    background: '#18191d',
    border: '1px solid #50505c',
    borderRadius: '6px',
    color: '#e8e8ea',
    fontSize: '0.82rem',
    padding: '0.35rem 0.65rem',
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
  };

  return (
    <div style={{ width: '100%', maxWidth: '480px', marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid #42424e' }}>
      <p style={{ color: '#c0c0cc', fontSize: '0.8rem', lineHeight: 1.6, marginBottom: '0.65rem' }}>
        If you wish to discuss matters of common interest, ranging from Gurdjieff studies
        to cooperative farming, federated governance and democracy, or data/systems,
        please send me a message here. I will normally reply the same day.
      </p>

      {status === 'sent' ? (
        <p style={{ color: '#4ade80', fontSize: '0.82rem', textAlign: 'center', padding: '0.75rem 0' }}>
          Message sent — thank you.
        </p>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
          <input
            type="text"
            name="website"
            value={website}
            onChange={e => setWebsite(e.target.value)}
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0 }}
          />
          <input
            type="text"
            placeholder="Name (optional)"
            value={name}
            onChange={e => setName(e.target.value)}
            className="dt-input"
            style={inputStyle}
          />
          <input
            type="email"
            placeholder="Email *"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="dt-input"
            style={inputStyle}
          />
          <textarea
            placeholder="Message *"
            value={message}
            onChange={e => setMessage(e.target.value)}
            required
            rows={4}
            className="dt-input"
            style={{ ...inputStyle, resize: 'vertical' }}
          />
          {status === 'error' && (
            <p style={{ color: '#ef4444', fontSize: '0.74rem', margin: 0 }}>{errMsg}</p>
          )}
          <button
            type="submit"
            disabled={status === 'sending'}
            className="dt-send-btn"
            style={{
              alignSelf: 'flex-start',
              background: 'transparent',
              border: '1px solid #50505c',
              color: '#c0c0cc',
              fontSize: '0.78rem',
              padding: '0.35rem 1rem',
              borderRadius: '6px',
              cursor: status === 'sending' ? 'default' : 'pointer',
            }}
          >
            {status === 'sending' ? 'sending…' : 'Send'}
          </button>
        </form>
      )}

      <p style={{ color: '#606068', fontSize: '0.73rem', marginTop: '0.6rem', lineHeight: 1.55 }}>
        Thank you,<br />
        David Twaddell<br />
        Scotland
      </p>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
    gap: '0.5rem',
  },
  privateMsg: {
    color: '#555',
    fontSize: '0.9rem',
    textAlign: 'center',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
    gap: '0.5rem',
    width: '100%',
    maxWidth: '560px',
  },
  card: (color) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.4rem',
    padding: '0.9rem 0.75rem',
    borderRadius: '10px',
    border: '1px solid #2a2b2f',
    background: '#18191d',
    textDecoration: 'none',
    color: '#e8e8ea',
    transition: 'border-color 0.15s, background 0.15s',
    cursor: 'pointer',
  }),
  cardIcon: (color) => ({
    color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  cardLabel: {
    fontSize: '0.78rem',
    fontWeight: 500,
    color: '#a0a0a8',
  },
  logoutBtn: {
    background: 'transparent',
    border: 'none',
    color: '#555',
    fontSize: '0.72rem',
    cursor: 'pointer',
    padding: '0.2rem 0.5rem',
  },
  loginBtn: {
    background: 'transparent',
    border: '1px solid #2a2b2f',
    color: '#555',
    fontSize: '0.72rem',
    padding: '0.35rem 0.85rem',
    borderRadius: '6px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
    transition: 'border-color 0.15s, color 0.15s',
  },
  error: {
    color: '#ef4444',
    fontSize: '0.75rem',
    textAlign: 'center',
    maxWidth: '280px',
  },
};

export default function Landing() {
  const [loggedIn, setLoggedIn] = useState(!!getToken());
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [nsec, setNsec]         = useState('');
  const [showNsec, setShowNsec] = useState(false);

  useEffect(() => {
    setLoggedIn(!!getToken());
  }, []);

  async function handleLogin() {
    setError('');
    setLoading(true);
    try {
      await loginWithNostr();
      setLoggedIn(true);
    } catch (e) {
      setError(e.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  async function handleNsecLogin() {
    setError('');
    setLoading(true);
    try {
      await loginWithNsec(nsec);
      setNsec('');
      setLoggedIn(true);
    } catch (e) {
      setError(e.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  }

  function handleLogout() {
    logout();
    setLoggedIn(false);
  }

  async function openWithSSO(href) {
    try {
      const r = await fetch('/api/auth/sso-token', { headers: authHeaders() });
      const { token } = await r.json();
      window.open(`${href}?sso=${encodeURIComponent(token)}`, '_blank');
    } catch {
      window.open(href, '_blank');
    }
  }

  if (loggedIn) {
    const pubkey = getPubkeyFromToken(getToken());
    return (
      <div style={s.page}>
        <div style={s.grid}>
          {LINKS.map(({ label, href, color, icon, sso, internal }) => (
            sso ? (
              <button
                key={label}
                onClick={() => openWithSSO(href)}
                style={{ ...s.card(color), border: '1px solid #2a2b2f', background: '#18191d', width: '100%' }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = color + '55'; e.currentTarget.style.background = '#1e1f24'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2b2f'; e.currentTarget.style.background = '#18191d'; }}
              >
                <span style={s.cardIcon(color)}>{icon}</span>
                <span style={s.cardLabel}>{label}</span>
              </button>
            ) : (
              <a
                key={label}
                href={href}
                {...(!internal && { target: '_blank', rel: 'noopener noreferrer' })}
                style={s.card(color)}
                onMouseEnter={e => { e.currentTarget.style.borderColor = color + '55'; e.currentTarget.style.background = '#1e1f24'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2b2f'; e.currentTarget.style.background = '#18191d'; }}
              >
                <span style={s.cardIcon(color)}>{icon}</span>
                <span style={s.cardLabel}>{label}</span>
              </a>
            )
          ))}
        </div>
        {pubkey && (
          <p style={{ color: '#3a3b40', fontSize: '0.68rem', fontFamily: 'monospace' }}>
            nostr:{shortKey(pubkey)}
          </p>
        )}
        <button style={s.logoutBtn} onClick={handleLogout}>sign out</button>
        <ContactForm />
      </div>
    );
  }

  return (
    <div style={s.page}>
      <p style={s.privateMsg}>This is a private site.</p>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem', marginTop: '1.5rem' }}>
        <button
          style={s.loginBtn}
          onClick={handleLogin}
          disabled={loading}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#6d5efc'; e.currentTarget.style.color = '#9d8fff'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = '#2a2b2f'; e.currentTarget.style.color = '#555'; }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} strokeLinecap="round" strokeLinejoin="round">
            <path d="M13 10V3L4 14h7v7l9-11h-7Z" />
          </svg>
          {loading ? 'connecting…' : 'nostr login'}
        </button>

        {!showNsec ? (
          <button
            style={{ ...s.loginBtn, fontSize: '0.65rem', borderColor: 'transparent' }}
            onClick={() => setShowNsec(true)}
          >
            use secret key
          </button>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', width: '100%', maxWidth: '280px' }}>
            <input
              type="password"
              placeholder="nsec1…"
              value={nsec}
              onChange={e => setNsec(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && nsec && handleNsecLogin()}
              autoFocus
              style={{
                width: '100%',
                background: '#18191d',
                border: '1px solid #2a2b2f',
                borderRadius: '6px',
                color: '#e8e8ea',
                fontSize: '0.78rem',
                padding: '0.4rem 0.7rem',
                outline: 'none',
                fontFamily: 'monospace',
              }}
            />
            <button
              style={s.loginBtn}
              onClick={handleNsecLogin}
              disabled={loading || !nsec.trim()}
            >
              {loading ? 'signing in…' : 'sign in'}
            </button>
          </div>
        )}

        {error && <p style={s.error}>{error}</p>}
      </div>
      <ContactForm />
    </div>
  );
}
